$(document).ready(function(){
    // 画面の幅をチェック
    if ($(window).width() < 768) {
      // 画面幅が768px以下の場合、スライダーを有効にする
      $('.awards').slick({
        autoplay: true, // 自動再生をオンにする
        autoplaySpeed: 2000, // 自動再生の速度（ミリ秒）
        arrows: false, // 矢印ナビゲーションの表示/非表示
        dots: true, // ドットナビゲーションの表示/非表示
        infinite: true, // 無限ループ
        slidesToShow: 1, // モバイル表示では1スライドのみ表示
        slidesToScroll: 1, // 一度のスクロールで移動するスライドの数
        width: '80vw' // スライドの幅を80vwに指定
      });
    }
  });
$(document).ready(function(){
    // 画面の幅をチェック
    if ($(window).width() < 768) {
      // 画面幅が768px以下の場合、スライダーを有効にする
      $('.menu-row').slick({
        autoplay: true, // 自動再生をオンにする
        autoplaySpeed: 2000, // 自動再生の速度（ミリ秒）
        arrows: true, // 矢印ナビゲーションの表示/非表示
        dots: true, // ドットナビゲーションの表示/非表示
        infinite: true, // 無限ループ
        slidesToShow: 1, // 一度に表示するスライドの数
        slidesToScroll: 1 // 一度のスクロールで移動するスライドの数
      });
    }
});
// $(document).ready(function() {
//     // 画面の幅をチェック
//     if ($(window).width() <= 768) {  // モバイルデバイスと想定される画面幅
//         var myVideo = $('#myVideo')[0]; // jQueryオブジェクトからDOM要素を取得
//         myVideo.setAttribute('autoplay', 'autoplay');
//         myVideo.setAttribute('muted', 'muted'); // ミュートに設定
//         myVideo.play(); // ビデオの再生を開始
//     }
// });
